import React from "react"
import { IntlProvider } from "react-intl"

import messages_es from "../../assets/data/locales/es.json"
import messages_en from "../../assets/data/locales/en.json"
import messages_pt from "../../assets/data/locales/pt.json"

const menu_messages = {
  en: messages_en,
  pt: messages_pt,
  es: messages_es
}

const Context = React.createContext()

class IntlProviderWrapper extends React.Component {
  state = {
    locale: localStorage.language,
    messages: menu_messages[localStorage.language]
  }

  render() {
    const { children } = this.props
    const { locale, messages } = this.state
    return (
      <Context.Provider
        value={{
          state: this.state,
          switchLanguage: language => {
            this.setState({
              locale: language,
              messages: menu_messages[language]
            })
          }
        }}
      >
        <IntlProvider
          key={locale}
          locale={locale}
          messages={messages}
          defaultLocale="pt"
        >
          {children}
        </IntlProvider>
      </Context.Provider>
    )
  }
}

export { IntlProviderWrapper, Context as IntlContext }
